module.exports = __webpack_public_path__ + "img/generic.a5f0fcad.svg";